(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/newUser/newUser.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2025 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<section class="user">',
'',
'  <h4>',
'    <a ng-link="users({\'id\': \'all\'})" translate>user.userlist</a>',
'    <span>/</span>',
'    <span translate>user.new_user</span>',
'  </h4>',
'',
'  <hr>',
'',
'  <div class="panel-body" ng-if="newUser.user">',
'    <hr>',
'    <div ng-inline="templates/userForm.tpl.html" ng-init="model=newUser.user;required=newUser.required"></div>',
'    <hr>',
'    <button ng-click="newUser.save()" class="btn btn-primary pull-right" translate>user.save</button>',
'    <a ng-link="users({id: \'all\'})" class="btn btn-link pull-right" translate>user.discard</a>',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();